import {
  getPoints,
  getHistoryPoint,
  getVoucherPoint,
  postRedeemPoint,
  getLeaderboard
} from '@/api/andalinpoint.api'

export const FETCH_POINT = 'FETCH_POINT'
export const FETCH_POINT_LOADING = 'FETCH_POINT_LOADING'
export const FETCH_POINT_DONE = 'FETCH_POINT_DONE'
export const FETCH_POINT_ERROR = 'FETCH_POINT_ERROR'

export const FETCH_POINT_HISTORY = 'FETCH_POINT_HISTORY'
export const FETCH_POINT_HISTORY_LOADING = 'FETCH_POINT_HISTORY_LOADING'
export const FETCH_POINT_HISTORY_DONE = 'FETCH_POINT_HISTORY_DONE'
export const FETCH_POINT_HISTORY_ERROR = 'FETCH_POINT_HISTORY_ERROR'

export const FETCH_POINT_VOUCHER = 'FETCH_POINT_VOUCHER'
export const FETCH_POINT_VOUCHER_LOADING = 'FETCH_POINT_VOUCHER_LOADING'
export const FETCH_POINT_VOUCHER_DONE = 'FETCH_POINT_VOUCHER_DONE'
export const FETCH_POINT_VOUCHER_ERROR = 'FETCH_POINT_VOUCHER_ERROR'

export const POST_POINT_REDEEM = 'POST_POINT_REDEEM'
export const POST_POINT_REDEEM_LOADING = 'POST_POINT_REDEEM_LOADING'
export const POST_POINT_REDEEM_DONE = 'POST_POINT_REDEEM_DONE'
export const POST_POINT_REDEEM_ERROR = 'POST_POINT_REDEEM_ERROR'

export const FETCH_POINT_LEADERBOARD = 'FETCH_POINT_LEADERBOARD'
export const FETCH_POINT_LEADERBOARD_LOADING = 'FETCH_POINT_LEADERBOARD_LOADING'
export const FETCH_POINT_LEADERBOARD_DONE = 'FETCH_POINT_LEADERBOARD_DONE'
export const FETCH_POINT_LEADERBOARD_ERROR = 'FETCH_POINT_LEADERBOARD_ERROR'

export default {
  [FETCH_POINT] (context) {
    context.commit(FETCH_POINT_LOADING)
    return getPoints()
      .then((response) => {
        context.commit(FETCH_POINT_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_POINT_ERROR, true)
        console.error(error)
      })
  },

  [FETCH_POINT_HISTORY] (context) {
    context.commit(FETCH_POINT_HISTORY_LOADING)
    return getHistoryPoint()
      .then((response) => {
        context.commit(FETCH_POINT_HISTORY_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_POINT_HISTORY_ERROR, true)
        console.error(error)
      })
  },

  [FETCH_POINT_VOUCHER] (context) {
    context.commit(FETCH_POINT_VOUCHER_LOADING)
    return getVoucherPoint()
      .then((response) => {
        context.commit(FETCH_POINT_VOUCHER_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_POINT_VOUCHER_ERROR, true)
        console.error(error)
      })
  },

  [POST_POINT_REDEEM] (context, payload) {
    context.commit(POST_POINT_REDEEM_LOADING)
    return postRedeemPoint(payload)
      .then((response) => {
        context.commit(POST_POINT_REDEEM_DONE, response)
      })
      .catch((error) => {
        context.commit(POST_POINT_REDEEM_ERROR, error)
        console.error(error)
      })
  },

  [FETCH_POINT_LEADERBOARD] (context) {
    context.commit(FETCH_POINT_LEADERBOARD_LOADING)
    return getLeaderboard()
      .then((response) => {
        context.commit(FETCH_POINT_LEADERBOARD_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_POINT_LEADERBOARD_ERROR, true)
        console.error(error)
      })
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/andalinpoint/actions.js